module.exports = __webpack_public_path__ + "media/images/emblems/Orvin-coat_of_arms-cf4bbbf905161321f00108eb6adae0c5.svg";